import { FC } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { buildLocalePath, DEFAULT_LOCALE, isSupportedLocale } from '@/utils/locale';
import { i18n } from '@/utils/i18n';

/**
 * Redirects bare paths (without locale prefix) to their locale-prefixed equivalents.
 * E.g. /login -> /pl/login, / -> /pl/
 * Preserves search params and hash.
 */
export const LocaleRedirect: FC = () => {
  const location = useLocation();
  const locale = isSupportedLocale(i18n.language) ? i18n.language : DEFAULT_LOCALE;
  const targetPath = buildLocalePath(location.pathname, locale);

  return (
    <Navigate
      to={{
        pathname: targetPath,
        search: location.search,
        hash: location.hash,
      }}
      replace
    />
  );
};
